import Api from "./Api";
import { API_VERSION } from "@/config/index";

export default {
  QuickBook(payload) {
    return Api().get(`/${API_VERSION}/webapp/quickbook`, { params: payload });
  }
};



// WEBPACK FOOTER //
// ./src/apiServices/QuickBookService.js